/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Component, Input, OnInit } from '@angular/core';
import { TaskDataString } from '../../../../../../../models/task.model';

@Component({
  selector: 'app-string-item',
  templateUrl: './string-item.component.html',
  styleUrls: ['./string-item.component.scss'],
  standalone: false
})
export class StringItemComponent implements OnInit {
  @Input() stringItem: TaskDataString = new TaskDataString('');
  constructor() {}

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {}
}
